import { render, staticRenderFns } from "./Datanalyze.vue?vue&type=template&id=31a25bf3&scoped=true"
import script from "./Datanalyze.vue?vue&type=script&lang=js"
export * from "./Datanalyze.vue?vue&type=script&lang=js"
import style0 from "./Datanalyze.vue?vue&type=style&index=0&id=31a25bf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a25bf3",
  null
  
)

export default component.exports